// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


//import Rails from 'rails-ujs'
import Rails from '@rails/ujs'

// import 'packs/swal-confirm'

// Setup the event listeners of rails-ujs
Rails.start()

// require("channels")
require('jquery');
require('jquery-ui-bundle');
require("slimScroll/jquery.slimscroll.min")
require("bootstrap/dist/js/bootstrap.min")

// require("sparkline/index")
// require("select2/dist/js/select2.full")
require("fancybox/jquery.fancybox");


$('[data-fancybox]').fancybox({
	touch: false
});

$(function () {
  $('.login[data-toggle="popover"]').popover({
    html: true,
    content: function(){
      return $($(this).data('contentwrapper')).html();
    }
  });
})